export {
  default,
  getServerSideProps,
} from 'src/pages/medical-education/videos/[subjectOrSlug]/index';
